<div class="kScrollToTopBtn" [class.show]="_show" (click)="scrollToTop()"><i class="kIconarrow_up"></i></div>
